import { type SVGProps, useId } from 'react'

export const ShieldIcon = (props: SVGProps<SVGSVGElement>) => {
  const id = useId()
  const clipPathId = `${id}-clip`

  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M0.812523 7.10938C0.817601 8.32812 0.944554 9.7957 1.25432 11.375H13C13 7.58164 13 3.79336 13 0C12.9899 0 12.9746 0 12.9645 0C12.741 0.00507813 12.5227 0.0558594 12.3246 0.147266L2.75744 4.20469C1.64026 4.67695 0.807445 5.77891 0.812523 7.10938ZM13.0356 11.375C13.0356 16.2043 13.0356 21.0285 13.0356 25.8527C13.4926 25.8527 13.9547 25.7512 14.3762 25.548C21.0082 22.3793 23.8063 16.316 24.7813 11.375H13.0356Z"
          fill="currentColor"
          opacity="0.4"
        />
        <path
          d="M13.0203 0H13.0355C13.2691 0 13.5027 0.0507813 13.716 0.147266L23.2781 4.20469C24.3953 4.67695 25.2281 5.77891 25.223 7.10938C25.2179 8.32812 25.091 9.7957 24.7812 11.375H13.0355V0H13H13.0152H13.0203ZM11.6594 25.5531C5.02732 22.3793 2.23435 16.316 1.25427 11.375H13V25.8527C12.5429 25.8527 12.0808 25.7512 11.6594 25.548V25.5531Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect height="100%" width="100%" />
        </clipPath>
      </defs>
    </svg>
  )
}
